const projects = [
    {
        id: 1,
        title: 'Los lirios hotel website',
        thumbSrc: `${process.env.PUBLIC_URL}/images/case-los-lirios-1`,
        tags: [
            {
                tagName: 'UI'
            },
            {
                tagName: 'Development'
            }
        ],
        text1: "For a small rural hotel in Lanzarote, I designed and developed this React site. ",
        imageSrc1: `${process.env.PUBLIC_URL}/images/case-los-lirios-1`,
        link: "https://www.loslirioshotel.es/",
        textLink: "Visit website"
    },{
        id: 2,
        title: 'Templates customization for a leading brand: Movistar salud website',
        thumbSrc: `${process.env.PUBLIC_URL}/images/case-movistar-1`,
        tags: [
            {
                tagName: 'UI'
            },
            {
                tagName: 'Development'
            }
        ],
        text1: "Movistar Salud is an online medical care platform and a client of Teladoc Health. They required customized templates on their website, including ad-hoc components and pages to offer a higher range of services in a more attractive and dynamic way.",
        text2: "With continuous feedback directly from the client, I prototyped, designed and developed all the customizations, ensuring that every change was incorporated into the design system.",
        text3: "Simultaneously, the entire project was being migrated to React, allowing me to participate in the migration process and achieve significant usability improvements in both the public and private sections of the site.",
        imageSrc1: `${process.env.PUBLIC_URL}/images/case-movistar-1`,
        imageSrc2: `${process.env.PUBLIC_URL}/images/case-movistar-2`,
        imageSrc3: `${process.env.PUBLIC_URL}/images/case-movistar-3`
    },
    {
        id: 3,
        title: 'Rethinking standard templates: UI makeover for Teladoc Health',
        thumbSrc: `${process.env.PUBLIC_URL}/images/case-teladoc-1`,
        tags: [
            {
                tagName: 'UI'
            },
            {
                tagName: 'Development'
            }
        ],
        text1: "Teladoc Health offers a dynamic template system for its clients. I was responsible for designing and adding new components, as well as maintaining the design system. Although the same predefined template was provided to all clients, I developed an alternative 'theme' for those who requested a different look and feel.",
        text2: "Due to the template system's technical constraints, I made this changes using only CSS, including an alternative navigation menu. One of the main challenges was maintaining a high flexibility for the content, as these projects are extremely dynamic.",
        slider1: {
            imageTop: `${process.env.PUBLIC_URL}/images/case-teladoc-1.webp`,
            imageBottom: `${process.env.PUBLIC_URL}/images/case-teladoc-2.webp`
        },
        slider2: {
            imageTop: `${process.env.PUBLIC_URL}/images/case-teladoc-3.webp`,
            imageBottom: `${process.env.PUBLIC_URL}/images/case-teladoc-4.webp`
        },
        imageSrc3: `${process.env.PUBLIC_URL}/images/case-teladoc-5`
    },
    {
        id: 4,
        title: 'A tool redesign to make daily work easier: Amos Admin',
        thumbSrc: `${process.env.PUBLIC_URL}/images/case-admin-1`,
        tags: [
            {
                tagName: 'UI'
            },
            {
                tagName: 'Development'
            }
        ],
        text1: "Admin is a backoffice panel used to manage clients web portals, assigned services and products, settings, and a content management system.<br><br>The software had been evolving for years without a design plan and needed a complete redesign, with a particular focus on reorganizing the complex navigation.",
        text2: "After a inicial heuristic evaluation, I conducted some user interviews to understand the challenges and pain points of existing users. With those insights I identified some patterns of friction in navigation and task completion.",
        text3: "A extensive work was done on the information architecture, with continuous iterations involving the backend team to ensure alignment with technical constraints, and other stakeholders. There were also several iterations using low-fidelity wireframes with end users to optimize usability for a tool they use daily. One of the most prominent features was the new navigation bar, which allows users to easily navigate from 'general' settings to the specific settings of the selected project",
        imageSrc1: `${process.env.PUBLIC_URL}/images/case-admin-1`,
        imageSrc2: `${process.env.PUBLIC_URL}/images/case-admin-2`,
        imageSrc3: `${process.env.PUBLIC_URL}/images/case-admin-3`
    },
    {
        id: 5,
        title: 'A training project I enjoyed: Vala app',
        thumbSrc: `${process.env.PUBLIC_URL}/images/case-vala-5`,
        tags: [
            {
                tagName: 'UX'
            },
            {
                tagName: 'UI'
            }
        ],
        text1: "<strong>(Project developed for a UX/UI design bootcamp)</strong> <br> Vala is a fictional brand preparing to enter the Spanish high-speed railway market, aiming to compete through pricing.",
        text2: "To inform the design process of the app, I employed several UX research techniques, including benchmarking, user personas, customer journeys, usability testing, and surveys.",
        text3: "Based on the insights gathered, I started with the wireframing and prototyping phases, iterating with real users to refine the designs and move toward more realistic, user-centered solutions.",
        imageSrc1: `${process.env.PUBLIC_URL}/images/case-vala-1`,
        imageSrc2: `${process.env.PUBLIC_URL}/images/case-vala-2`,
        imageSrc3: `${process.env.PUBLIC_URL}/images/case-vala-3`,
        imageSrc6: `${process.env.PUBLIC_URL}/images/case-vala-6`,
        imageSrc7: `${process.env.PUBLIC_URL}/images/case-vala-7`,
        gif: `${process.env.PUBLIC_URL}/images/case-vala-4`
    },
    {
        id: 6,
        title: 'A training project I enjoyed: Dayfulness app',
        thumbSrc: `${process.env.PUBLIC_URL}/images/case-dayfulness-2`,
        tags: [
            {
                tagName: 'UX'
            },
            {
                tagName: 'UI'
            }
        ],
        text1: "<strong>(Project developed for a UX/UI design bootcamp)</strong> <br> Dayfulness is a fictional coaching app inspired by the Plenitude Diary. Its goal is to help users, with guidance from a coach, identify the activities or situations that stimulate them or enhance their well-being.",
        text2: "I conducted research on similar apps and found none that effectively serve as an intuitive bridge between coach and coachee. Both professional coaches and a diverse group of users participated in the usability tests, providing feedback on both the mockups and detailed prototypes.",
        text3: "Given the app’s sensitive nature, I chose a design approach based on neumorphism to create a tactile, immersive feel, while prioritizing simplicity and ease of use.",
        imageSrc1: `${process.env.PUBLIC_URL}/images/case-dayfulness-1`,
        imageSrc2: `${process.env.PUBLIC_URL}/images/case-dayfulness-2`,
        imageSrc3: `${process.env.PUBLIC_URL}/images/case-dayfulness-3`,
        imageSrc4: `${process.env.PUBLIC_URL}/images/case-dayfulness-4`,
        videoSrc: `${process.env.PUBLIC_URL}/images/case-dayfulness-video.mp4`,
        posterSrc: `${process.env.PUBLIC_URL}/images/case-dayfulness-poster.webp`
    },
];

export default projects;